import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import FounderPage from './pages/FounderPage';
import WealthFlowPage from './pages/WealthFlowPage';
import RisingStarsPage from './pages/RisingStarsPage';
import SpaceTimeFlowPage from './pages/SpaceTimeFlowPage';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <GoogleAnalytics />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/wealth-flow" element={<WealthFlowPage />} />
            <Route path="/rising-stars" element={<RisingStarsPage />} />
            <Route path="/spacetime-flow" element={<SpaceTimeFlowPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
